module.exports = __webpack_public_path__ + "img/corrosive.299da70b.png";